import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckInsComponent } from './check-ins/check-ins.component';
import { CheckInsService } from './check-ins.service';
import { WsgSharedModule } from '@morningstar/wsg/shared';
import { LocationsModule } from '../../shared/locations/locations.module';
import { DayOfWeekCheckInsComponent } from './day-of-week-check-ins/day-of-week-check-ins.component';
import { ChartAllModule, RangeNavigatorAllModule, AccumulationChartAllModule, LineSeriesService, CategoryService, LegendService, TooltipService, DataLabelService } from '@syncfusion/ej2-angular-charts';
import { ButtonModule } from '@syncfusion/ej2-angular-buttons';
import { MonthlyCheckInsComponent } from './monthly-check-ins/monthly-check-ins.component';

@NgModule({
  declarations: [
    CheckInsComponent,
    DayOfWeekCheckInsComponent,
    MonthlyCheckInsComponent
  ],
  imports: [
    CommonModule,
    WsgSharedModule,
    LocationsModule,
    ChartAllModule, 
    RangeNavigatorAllModule, 
    ButtonModule, 
    AccumulationChartAllModule,
  ],
  providers: [
    CheckInsService,
    CategoryService, 
    LegendService, 
    TooltipService, 
    DataLabelService, 
    LineSeriesService
  ],
  exports: [
    CheckInsComponent,
    DayOfWeekCheckInsComponent,
    MonthlyCheckInsComponent
  ]
})
export class CheckInsModule { }
